import React from "react";
import ContainerWrapper from "./ContainerWrapper";
import SurgeryMain from "Components/Surgery/SurgeryMain";
import { connect } from "react-redux";
// const SurgeryMain = React.lazy(() => import("Components/Surgery/SurgeryMain"));

const Surgery = () => {
  return (
    // <ContainerWrapper>
    <SurgeryMain />
    // </ContainerWrapper>
  );
};

export default Surgery; // Surgery;
